import React from 'react';

/**
 * Badge - A simple badge component with customizable text
 * 
 * @param {Object} props
 * @param {string} props.text - Text to display in the badge
 * @param {string} props.className - Additional CSS classes
 */
const Badge = ({ 
  text = "badge", 
  className = "" 
}) => {
  return (
    <div 
      data-size="Default" 
      data-themes="Success" 
      data-type="Solid" 
      data-variant="Default" 
      className={`inline-flex justify-start items-start ${className}`}
    >
      <div 
        data-type="Default" 
        data-variant="Default" 
        className="px-[12px] py-[4px] bg-[#197A00] rounded-[4px] flex justify-center items-center gap-[10px]"
      >
        <div className="text-center text-white text-[10px] font-normal font-['Arial'] uppercase leading-[16px] w-auto h-[16px] flex items-center justify-center">
          {text}
        </div>
      </div>
    </div>
  );
};

export default Badge;